import '.gr{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.gs{padding-left:1.5rem;}.ssr-plugin'
import '.gt{margin:1rem 0;}.ssr-plugin'
import '.gu{color:var(--gray-700);}.ssr-plugin'
import '.gv{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="gr gs gt gu gv"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
